module.exports = __webpack_public_path__ + "assets/img/send-verify-mail.b9bca8d8.png";